import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home center p-40" }
const _hoisted_2 = { class: "p-10" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("login")
const _hoisted_4 = { class: "p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("home")
const _hoisted_6 = { class: "p-10" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("question")
const _hoisted_8 = { class: "p-10" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("assessment-report")
const _hoisted_10 = { class: "p-10" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("health-package")
const _hoisted_12 = { class: "p-10" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("package-for-you")
const _hoisted_14 = { class: "p-10" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("payment")
const _hoisted_16 = { class: "p-10" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("qr-code")
const _hoisted_18 = { class: "p-10" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("package-details")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/home')))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/question')))
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/assessment-report')))
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/health-package')))
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/package-for-you')))
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/payment')))
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (
          _ctx.$router.push({
            path: '/qr-code',
            query: { orderId: '3df617d3-911e-4124-9d39-633d4dcca2ea' },
          })
        ))
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (
          _ctx.$router.push({
            path: '/package-details',
            query: { orderId: '3df617d3-911e-4124-9d39-633d4dcca2ea' },
          })
        ))
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      })
    ])
  ]))
}